import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import AdminLayoutSideNav from "../../../layouts/LayoutTopSideBottom/AdminLayoutSideNav";

function AdminView(props) {
  const { match, children } = props;

  return (
    <AdminLayoutSideNav match={props.match}>
      {/* Breadcrumbs and Approval Option */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Breadcrumbs match={match} />
      </div>

      {children}
    </AdminLayoutSideNav>
  );
}

AdminView.propTypes = {
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminView),
);
